import React from "react";
import classes from "./Investigation.module.css";
import { Typography, Grid } from "@mui/material";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

const InvestigatorDetails = ({
  indexOfInvestigatorsDeatilsArray,
  InvestigatorTabDetails,
}) => {
  const {
    vendorName,
    mobileNumber,
    city,
    email,
    caseGrade,
    gradeStatus,
    gradeSubStatus,
  } = useSelector((state) => state?.approvalVendorSlice?.investigatorDetails);

  return (
    <>
      <div style={{ borderBottom: "1px solid #D9D9D9" }}>
        <Grid
          container
          spacing={2}
          sx={{ mt: "1.5rem", mb: "1rem", pl: "1.6rem" }}
        >
          <Grid item xs={3}>
            <Typography
              className={classes["investigators-tab-user-details-label"]}
            >
              Name:
            </Typography>
            <Typography
              className={classes["investigators-tab-user-details-content"]}
            >
              {vendorName}
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography
              className={classes["investigators-tab-user-details-label"]}
            >
              Mobile No.:
            </Typography>
            <Typography
              className={classes["investigators-tab-user-details-content"]}
            >
              {mobileNumber}
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography
              className={classes["investigators-tab-user-details-label"]}
            >
              Location:
            </Typography>
            <Typography
              className={classes["investigators-tab-user-details-content"]}
            >
              {city}
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography
              className={classes["investigators-tab-user-details-label"]}
            >
              Email ID:
            </Typography>
            <Typography
              className={classes["investigators-tab-user-details-content"]}
            >
              {email}
            </Typography>
          </Grid>
        </Grid>
      </div>

      <div style={{ borderBottom: "1px solid #D9D9D9" }}>
        <Grid
          container
          spacing={2}
          sx={{ mt: "1rem", mb: "1rem", pl: "1.6rem" }}
        >
          <Grid item xs={12} sx={{ paddingTop: "unset !important" }}>
            <Typography
              className={classes["investigation-assigned-blocks-heading"]}
            >
              Grade Case
            </Typography>
          </Grid>
          <Grid item xs={3} sx={{ paddingTop: "unset !important" }}>
            <Typography
              className={classes["investigators-tab-user-details-label"]}
            >
              Case Grade
            </Typography>
            <Typography
              className={classes["investigators-tab-user-details-content"]}
            >
              {caseGrade}
            </Typography>
          </Grid>

          <Grid item xs={3} sx={{ paddingTop: "unset !important" }}>
            <Typography
              className={classes["investigators-tab-user-details-label"]}
            >
              Grade Status
            </Typography>
            <Typography
              className={classes["investigators-tab-user-details-content"]}
            >
              {gradeStatus}
            </Typography>
          </Grid>
          <Grid item xs={3} sx={{ paddingTop: "unset !important" }}>
            <Typography
              className={classes["investigators-tab-user-details-label"]}
            >
              Grade Sub Status
            </Typography>
            <Typography
              className={classes["investigators-tab-user-details-content"]}
            >
              {gradeSubStatus}
            </Typography>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

InvestigatorDetails.propTypes = {
  indexOfInvestigatorsDeatilsArray: PropTypes.number,
};

export default InvestigatorDetails;
